import LinkIcon from "assets/icons/link.svg";
import { ReactComponent as PencilSVG } from "assets/icons/pencil.svg";
import { Text } from "components/Text";
import React from 'react';
import { colors } from "theme";

const styles = {
  circleButtonBody: {
    background: "#FFFFFF",
    borderRadius: "50%",
    width: 20,
    height: 20,
    right: 0,
    top: 3,
    cursor: "pointer",
  },
  textIconButton: {
    color: colors.primaryColor,
    fontSize: 17,
    fontWeight: "bolder",
  },
};



const BulkClassUploadCoverImage = ({ handleOpenCoverImage,croppedImage }) => {

  
  return (
    <div className="class__upload__image__container">
      {croppedImage ? (
        <div className="row mb-5">
          <div className="position-relative">
            <div
              
            >
              <img
                alt=""
                src={croppedImage}
                style={{
                  objectFit: "fill",
                  maxWidth: "100%",
                  width: "100%",
                }}
                className={
                  "image"
                }
                name="logoImg"
              />
            </div>
            <div
              className="shadow text-center justify-content-center align-items-center position-absolute"
              style={{
                ...styles.circleButtonBody,
                right:  0,
              }}
              onClick={handleOpenCoverImage}
            >
              <PencilSVG />
            </div>
          </div>

          <div className="col-sm-12">
            <Text style={{ color: "#B5B5C3", fontSize: 12 }}>
              Reccomended file size: 800W X 800H, allowed file types: png,
              jpg, jpeg.
            </Text>
          </div>
        </div>
      ) : (
        <>
        <img src={LinkIcon} alt="" />
          <div className="class__upload__image" onClick={() => {
            handleOpenCoverImage()
          }}>
           Choose an image
          </div>
          <div className="class__upload__image-text">
            from your files
          </div>
        </>
      )}
    </div>

  )
}

export default BulkClassUploadCoverImage